import { PropsWithChildren } from 'react'

type FooterProps = {}

export const Footer = ({ children }: PropsWithChildren<FooterProps>) => {
  return (
    <div className="flex flex-row gap-5 items-center w-full">{children}</div>
  )
}
